import styled from 'styled-components';

import STATUS from './constants';

const { COMPLETE, PROCESS } = STATUS;

export const Title = styled.div`
  color: ${({ status, theme: { palette } }) =>
    status === PROCESS
      ? palette.primary.default
      : status === COMPLETE
        ? palette.success.default
        : palette.darkGrey};

  font-weight: ${({ status, theme: { fonts } }) =>
    status === PROCESS ? fonts.weight.thick : fonts.normal};
`;



// WEBPACK FOOTER //
// ./src/components/Steps/elements.js